/**
 * Фильтрация и рандомизация друзей фонда
 */

(function() {
	'use strict';

	/**
	 * Функция для перемешивания массива (Fisher-Yates shuffle)
	 */
	function shuffleArray(array) {
		const newArray = [...array];
		for (let i = newArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[newArray[i], newArray[j]] = [newArray[j], newArray[i]];
		}
		return newArray;
	}

	/**
	 * Фильтрация и отображение друзей
	 */
	function filterAndDisplayFriends(filterSelect, friendsList) {
		const selectedStatus = filterSelect.value;
		const allItems = Array.from(friendsList.querySelectorAll('.friend-item'));
		
		// Фильтруем элементы по статусу
		let filteredItems = allItems;
		if (selectedStatus !== 'all') {
			filteredItems = allItems.filter(function(item) {
				return item.getAttribute('data-status') === selectedStatus;
			});
		}

		// Перемешиваем отфильтрованные элементы
		const shuffledItems = shuffleArray(filteredItems);

		// Скрываем все элементы
		allItems.forEach(function(item) {
			item.style.display = 'none';
			item.style.order = '0';
		});

		// Показываем и устанавливаем порядок для отфильтрованных элементов
		shuffledItems.forEach(function(item, index) {
			item.style.display = '';
			item.style.order = index;
		});
	}

	/**
	 * Инициализация фильтра для блока
	 */
	function initBlockFilter(blockElement) {
		const filterSelect = blockElement.querySelector('.friends-status-filter');
		const friendsList = blockElement.querySelector('.friends-list');

		if (!filterSelect || !friendsList) {
			return;
		}

		// Устанавливаем flexbox для корректной работы order
		// friendsList.style.display = 'flex';
		// friendsList.style.flexWrap = 'wrap';

		// Изначально показываем всех в рандомном порядке
		filterAndDisplayFriends(filterSelect, friendsList);

		// Добавляем обработчик изменения фильтра
		filterSelect.addEventListener('change', function() {
			filterAndDisplayFriends(filterSelect, friendsList);
		});
	}

	/**
	 * Инициализация всех блоков на странице
	 */
	function init() {
		const blocks = document.querySelectorAll('.block-friends');
		blocks.forEach(function(block) {
			initBlockFilter(block);
		});
	}

	// Запускаем инициализацию
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

})();
